import React from 'react';
import { ValidHex } from '@lendi-ui/commons/colours';
import ChatBubble from '@lendi-ui/icon/ChatBubble';

import { Button, IconContainer } from './index.style';

interface CommentsButtonProps {
  children: React.ReactNode;
  handleShowModal: () => void;
  color?: ValidHex;
}

function CommentsButton(props: CommentsButtonProps) {
  const { color, handleShowModal, children } = props;
  return (
    <Button color={color} type="button" onClick={handleShowModal}>
      {children}
      <IconContainer>
        <ChatBubble />
      </IconContainer>
    </Button>
  );
}

export default CommentsButton;
